<div class="main">
  <div [hidden]="show==true" class="section">
    <div class="header">
      <div class="label">
        {{'POST_SHIPMENT.postShipment' | translate}}
      </div>
      <div class="help">
        <app-help [helpData]="helpData"></app-help>
      </div>
    </div>
    <div class="organisation">
      {{'POST_SHIPMENT.orgName' | translate}}
      <input class="inputField" [matAutocomplete]="organisationDD" style="margin-left: 10px; width: 400px;"
        [(ngModel)]="selectedOrganisation.name">
      <mat-autocomplete #organisationDD="matAutocomplete" (optionSelected)='orgChange($event.option.value)'>
        <mat-option *ngFor="let org of Organisations | search:selectedOrganisation.name:'org':selectedOrganisation._id"
          [value]="org">
          <span>{{org.name}}</span>
        </mat-option>
      </mat-autocomplete>
      <img src="assets/Artboard – 12.jpg" class="master-icon" style="margin-top: 3px;"
        (click)="openModal(modalScreens[0]);" />
      <div class="mapIcon">

        <img src="assets/Artboard – 11.jpg" class="map-icon" (click)="show=true;" />
      </div>

    </div>
    <div class="form" *ngIf="CarrierPrefs">
      <div class="left">

        <div class="formItem" cdkDropList (cdkDropListDropped)="drop($event)">

          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.pickup' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon" (click)="openModal(modalScreens[1]);" />
              <!-- <app-help ></app-help> -->
            </div>
          </div>
          <div style=" max-height: 40vh; overflow: auto;">
            <div class="formElement" style="margin-bottom: 6px; margin-top: 10px; "
              *ngFor="let pickup of pickupLocations;let last = last; let index = index; let first = first;" cdkDrag>
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
              <div class="dragLoca grabbable">
                <i class="material-icons">
                  drag_indicator
                </i>
              </div>
              <div class="inputElement" style="background-color: #fafafa; padding-left: 10px;">

                <div class="inputs">
                  <div class="input">
                    <input class="inputField" style="width: 80%;" [matAutocomplete]="pickupDD"
                      [(ngModel)]="pickup.area">
                    <span class="pickupIndex">P{{index+1}}</span>
                    <mat-autocomplete #pickupDD="matAutocomplete"
                      (optionSelected)='selectLocation(index,$event.option.value)'>
                      <mat-option
                        *ngFor="let location of CarrierPrefs.locations| search:pickup.area:'loc':pickup.loc_id"
                        [value]="location">
                        <span><b>{{location.name}}</b> - {{location.area}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="input">
                    <input type="text" style="width: 40%;" class="inputField"
                      [placeholder]="'POST_SHIPMENT.date' | translate" [(ngModel)]="pickup.date"
                      (click)="pickerPickup.open()" [min]="minDate.pick" [max]="maxDate.pick"
                      [matDatepicker]="pickerPickup" />
                    <mat-datepicker #pickerPickup (closed)="setPickDateTime(index, pickup);picker.open()">
                    </mat-datepicker>
                    <input style="width:30%;" type="text" [placeholder]="'POST_SHIPMENT.time' | translate"
                      class="inputField" [(ngModel)]="pickup.time" [ngxTimepicker]="picker" style="margin-left: 5px;">
                    <ngx-material-timepicker class="timePick" #picker (closed)="setPickDateTime(index, pickup)">
                    </ngx-material-timepicker>
                    <i class="material-icons pull-right add-icon calendar"
                      style='margin-left: 6px; margin-top: 10px; color: #494949;'>date_range</i>
                  </div>

                </div>
              </div>
              <div class="addMore">
                <img src="assets/delete.svg" alt="" *ngIf="!first" (click)="removeLocation(index)">
                <img src="assets/plus.svg" alt="" *ngIf="last && pickupLocations[index].loc_id" (click)="addLocation()">
                <!--  && pickupLocations[index].loc_id-->
              </div>

            </div>
          </div>


        </div>
        <div class="formItem marginTop-25">

          <div class="formLabel">
            <div class="label">
              <span>{{'POST_SHIPMENT.vehType' | translate}}</span>
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement">
            <div class="inputElement">

              <div class="inputs">
                <div class="input">
                  <div class="inputWithIcon">

                    <input class="inputField" style="width: 100%;" [matAutocomplete]="pickupDD"
                      [(ngModel)]="vehicleKey.name">
                    <span class="material-icons cancelIcon" *ngIf="vehicleKeyLength" (click)="clearVehicle()">
                      cancel
                    </span>
                    <mat-autocomplete #pickupDD="matAutocomplete" (optionSelected)='selectVehicle($event.option.value)'>
                      <mat-option *ngFor="let vehicle of vehicles| search:vehicleKey.name:'vehicle'" [value]="vehicle">
                        <span>{{vehicle.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="formItem marginTop-25">

          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.noOfVeh' | translate}}</span>
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement" style="margin-bottom: 6px;">
            <div class="inputElement">

              <div class="inputs">
                <div class="input">
                  <input class="inputField" style="width: 80%;" [(ngModel)]="noOfVehicles">

                </div>

              </div>
            </div>

          </div>
        </div>

        <div class="formItem marginTop-25">

          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup> {{'POST_SHIPMENT.weightPerVeh' | translate}}</span>
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement" style="margin-bottom: 6px;">
            <div class="inputElement">

              <div class="inputs">
                <div class="input">
                  <input class="inputField" style="width: 80%;" [(ngModel)]="weightPerVehicle">
                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="formItem">
          <div class="split">
            <div class="biddingToggle">
              {{'POST_SHIPMENT.payMode' | translate}}
              <div class="bidToggle">
                <div class="yes" (click)="pay = true; check();" [ngClass]="{'selected' : pay}">
                  {{'POST_SHIPMENT.cash' | translate}}</div>
                <div class="no" (click)="pay = false; check();" [ngClass]="{'selected' : !pay}">
                  {{'POST_SHIPMENT.payLater' | translate}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">

        <div class="formItem" cdkDropList (cdkDropListDropped)="drop($event, 'drop')">

          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.delivery' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon"
                (click)="openModal(modalScreens[1],'Delivery Address');" />
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div style=" max-height: 40vh; overflow: auto;">


            <div class="formElement" style="margin-bottom: 6px; margin-top: 10px;"
              *ngFor="let delivery of deliveryLocations;let last = last; let index = index; let first = first;" cdkDrag>
              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
              <div class="dragLoca grabbable">
                <i class="material-icons">
                  drag_indicator
                </i>
              </div>
              <div class="inputElement" style="background-color: #fafafa;padding-left: 10px;">

                <div class="inputs">
                  <div class="input">
                    <input class="inputField" style="width: 80%;" [matAutocomplete]="dropDD"
                      [(ngModel)]="delivery.area">
                    <span class="dropIndex">D{{index+1}}</span>
                    <mat-autocomplete #dropDD="matAutocomplete"
                      (optionSelected)='selectLocation(index,$event.option.value, "drop")'>
                      <mat-option
                        *ngFor="let location of CarrierPrefs.locations| search:delivery.area:'loc':delivery.loc_id"
                        [value]="location">
                        <span><b>{{location.name}}</b> - {{location.area}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                  <div class="input">
                    <input type="text" style="width: 40%;" class="inputField"
                      [placeholder]="'POST_SHIPMENT.date' | translate" [(ngModel)]="delivery.date" [min]="minDate.drop"
                      [max]="maxDate.drop" (click)="pickerPickup.open()" [matDatepicker]="pickerPickup" />
                    <mat-datepicker #pickerPickup (closed)="setPickDateTime(index, delivery);picker.open()">
                    </mat-datepicker>
                    <input style="width:30%;" type="text" [placeholder]="'POST_SHIPMENT.time' | translate"
                      class="inputField" [(ngModel)]="delivery.time" [ngxTimepicker]="picker" style="margin-left: 5px;">
                    <ngx-material-timepicker class="timePick" #picker (closed)="setPickDateTime(index, delivery)">
                    </ngx-material-timepicker>
                    <i class="material-icons pull-right add-icon calendar"
                      style='margin-left: 6px; margin-top: 10px; color: #494949;'>date_range</i>
                  </div>

                </div>
              </div>
              <div class="addMore">
                <img src="assets/delete.svg" alt="" *ngIf="!first" (click)="removeLocation(index, 'drop')">
                <img src="assets/plus.svg" alt="" *ngIf="last && deliveryLocations[index].loc_id"
                  (click)="addLocation('drop')">
              </div>

            </div>
          </div>
        </div>
        <div class="formItem marginTop-25">
          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.material' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon" (click)="openModal(modalScreens[4]);" />
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement">
            <div class="inputElement">
              <div class="inputs">
                <div class="input">

                  <mat-form-field class="materialFeild">
                    <mat-chip-list #chipList aria-orientation="vertical">
                      <mat-chip *ngFor="let m of materials; let i = index;" [selectable]="selectable"
                        [removable]="removable" (removed)="removeElement(i, 'material')" class="chips">
                        {{m.name}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" [matAutocomplete]="materialDD" [(ngModel)]="materialKey">
                    </mat-chip-list>

                    <mat-autocomplete #materialDD="matAutocomplete"
                      (optionSelected)='selectMaterial($event.option.value)'>
                      <mat-option *ngFor="let material of CarrierPrefs.materials| search:materialKey:'materials'"
                        [value]="material">
                        <span>{{material.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>


              </div>
            </div>

          </div>
        </div>
        <div class="formItem marginTop-25">
          <div class="formLabel">
            <div class="label">
              <span>{{'POST_SHIPMENT.permits' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon" (click)="openModal(modalScreens[3]);" />
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement">
            <div class="inputElement">

              <div class="inputs">
                <div class="input">
                  <mat-form-field class="materialFeild">
                    <mat-chip-list #chipList aria-orientation="vertical">
                      <mat-chip *ngFor="let m of permits; let i = index;" [selectable]="selectable"
                        [removable]="removable" (removed)="removeElement(i, 'permit')" class="chips">
                        {{m.name}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" [matAutocomplete]="permitDD" [(ngModel)]="permitKey">
                    </mat-chip-list>

                    <mat-autocomplete #permitDD="matAutocomplete" (optionSelected)='selectPermits($event.option.value)'>
                      <mat-option *ngFor="let permit of CarrierPrefs.permits| search:permitKey:'permit'"
                        [value]="permit">
                        <span>{{permit.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>


              </div>
            </div>

          </div>
        </div>

        <div class="formItem marginTop-25">
          <div class="formLabel">
            <div class="label">
              <span>{{'POST_SHIPMENT.accessories' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon" (click)="openModal(modalScreens[2]);" />
              <!-- <app-help [header]="helpHeader" [content]="helpContent"></app-help> -->
            </div>
          </div>
          <div class="formElement">
            <div class="inputElement">

              <div class="inputs">
                <div class="input">

                  <mat-form-field class="materialFeild">
                    <mat-chip-list #chipList aria-orientation="vertical">
                      <mat-chip *ngFor="let m of accessories; let i = index;" [selectable]="selectable"
                        [removable]="removable" (removed)="removeElement(i, 'accessories')" class="chips">
                        {{m.name}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" [matAutocomplete]="a" [(ngModel)]="accKey">
                    </mat-chip-list>

                    <mat-autocomplete #a="matAutocomplete" (optionSelected)='selectAccessory($event.option.value)'>
                      <mat-option *ngFor="let acc of CarrierPrefs.accessories| search:accKey:'permit'" [value]="acc">
                        <span>{{acc.name}}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>


              </div>
            </div>

          </div>
        </div>


        <div class="submitButton">
          <div class="button" style="margin-right: 8px;background-color: #6e6e6e" (click)="clearAllFields();">
            {{'POST_SHIPMENT.clear' | translate}}
          </div>
          <div class="button" appDbclick (debounceClick)="postShipment();">
            {{'POST_SHIPMENT.submitButton' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="secondSection" [hidden]="show==false">
    <div class="form" *ngIf="CarrierPrefs">
      <div class="pickupPane">
        <div class="formItem" cdkDropList (cdkDropListDropped)="drop($event)">
          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.pickup' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon" (click)="openModal(modalScreens[1]);" />
            </div>
          </div>
          <div class="formElement" style="margin-bottom: 6px;"
            *ngFor="let pickup of pickupLocations;let last = last; let index = index; let first = first;" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div class="dragLoca grabbable">
              <i class="material-icons">
                drag_indicator
              </i>
            </div>
            <div class="inputElement" style="background-color: #fafafa;">

              <div class="inputs">
                <div class="input">
                  <input class="inputField" style="width: 80%;" [matAutocomplete]="pickupDD" [(ngModel)]="pickup.area">
                  <span class="pickupIndex">P{{index+1}}</span>
                  <mat-autocomplete #pickupDD="matAutocomplete"
                    (optionSelected)='selectLocation(index,$event.option.value)'>
                    <mat-option *ngFor="let location of CarrierPrefs.locations| search:pickup.area:'loc'"
                      [value]="location">
                      <span>{{location.area}}</span>
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div class="input">
                  <input type="text" style="width: 40%;" class="inputField"
                    [placeholder]="'POST_SHIPMENT.date' | translate" [(ngModel)]="pickup.date"
                    (click)="pickerPickup.open()" [min]="minDate.pick" [max]="maxDate.pick"
                    [matDatepicker]="pickerPickup" />
                  <mat-datepicker #pickerPickup (closed)="setPickDateTime(index, pickup);picker.open()">
                  </mat-datepicker>
                  <input style="width:30%;" type="text" [placeholder]="'POST_SHIPMENT.time' | translate"
                    class="inputField" [(ngModel)]="pickup.time" [ngxTimepicker]="picker">
                  <ngx-material-timepicker class="timePick" #picker (closed)="setPickDateTime(index, pickup)">
                  </ngx-material-timepicker>
                  <i class="material-icons pull-right add-icon calendar"
                    style='margin-left: 6px; margin-top: 10px; color: #494949;'>date_range</i>
                </div>

              </div>
            </div>
            <div class="addMore">
              <img src="assets/delete.svg" alt="" *ngIf="!first" (click)="removeLocation(index)">
              <img src="assets/plus.svg" alt="" *ngIf="last && pickupLocations[index].loc_id" (click)="addLocation()">
            </div>

          </div>
        </div>
      </div>
      <div class="deliveryPane">
        <div class="formItem" cdkDropList (cdkDropListDropped)="drop($event, 'drop')">

          <div class="formLabel">
            <div class="label">
              <span><sup class="required">*</sup>{{'POST_SHIPMENT.delivery' | translate}}</span>
              <img src="assets/Artboard – 12.jpg" class="master-icon"
                (click)="openModal(modalScreens[1],'Delivery Address');" />
            </div>
          </div>
          <div class="formElement" style="margin-bottom: 6px;"
            *ngFor="let delivery of deliveryLocations;let last = last; let index = index; let first = first;" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div class="dragLoca grabbable">
              <i class="material-icons">
                drag_indicator
              </i>
            </div>
            <div class="inputElement" style="background-color: #fafafa;">

              <div class="inputs">
                <div class="input">
                  <input class="inputField" style="width: 80%;" [matAutocomplete]="dropDD" [(ngModel)]="delivery.area">
                  <span class="dropIndex">D{{index+1}}</span>
                  <mat-autocomplete #dropDD="matAutocomplete"
                    (optionSelected)='selectLocation(index,$event.option.value, "drop")'>
                    <mat-option *ngFor="let location of CarrierPrefs.locations| search:delivery.area:'loc'"
                      [value]="location">
                      <span>{{location.area}}</span>
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div class="input">
                  <input type="text" style="width: 40%;" class="inputField"
                    [placeholder]="'POST_SHIPMENT.date' | translate" [(ngModel)]="delivery.date"
                    (click)="pickerPickup.open()" [min]="minDate.drop" [max]="maxDate.drop"
                    [matDatepicker]="pickerPickup" />
                  <mat-datepicker #pickerPickup (closed)="setPickDateTime(index, delivery);picker.open()">
                  </mat-datepicker>
                  <input style="width:30%;" type="text" [placeholder]="'POST_SHIPMENT.time' | translate"
                    class="inputField" [(ngModel)]="delivery.time" [ngxTimepicker]="picker">
                  <ngx-material-timepicker class="timePick" #picker (closed)="setPickDateTime(index, delivery)">
                  </ngx-material-timepicker>
                  <i class="material-icons pull-right add-icon calendar"
                    style='margin-left: 6px; margin-top: 10px; color: #494949;'>date_range</i>
                </div>

              </div>
            </div>
            <div class="addMore">
              <img src="assets/delete.svg" alt="" *ngIf="!first" (click)="removeLocation(index, 'drop')">
              <img src="assets/plus.svg" alt="" *ngIf="last && deliveryLocations[index].loc_id"
                (click)="addLocation('drop')">
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="mapSection">
      <img src="assets/Artboard – 13.jpg" class="map-icon" (click)="show=false;" />
      <div class="distance">
        <div class="label" [hidden]="optimize == true">
          Distance - {{totalDistance.toFixed(2)}} kms
        </div>
      </div>
      <div class="optimizedDistance">
        <div class="label" [hidden]="optimize == false">
          {{'POST_SHIPMENT.optimizedRoute' | translate}} - {{totalDistance.toFixed(2)}}{{'POST_SHIPMENT.kms' |
          translate}} -> <span style="color:#33AFE3">{{optimizedDistance.toFixed(2)}}{{'POST_SHIPMENT.km' |
            translate}}</span>
        </div>
      </div>
      <div class="map" id="pathMap" style="height: 100%;"></div>
      <div class="optimizeButton">
        <div class="button"
          [hidden]="(optimize == true || confirm) || deliveryLocations.length <3 || pickupLocations.length <3"
          style="background-color: #104ab3" (click)="optimizeRoute();optimize = true">
          Optimize Route
        </div>
      </div>
      <div class="confirmButton">
        <div class="button" [hidden]="(optimize == false || confirm)" style="background-color: #22b617"
          (click)="confirm = true">
          <i class="material-icons">check</i>Confirm
        </div>
      </div>
      <div class="backButton">
        <div class="button" [hidden]="optimize == false || confirm" (click)="optimize = false">
          <i class="material-icons">arrow_back</i>Back
        </div>
      </div>
    </div>
  </div>
</div>